/**
 * Xingyu PDP — sync preço/compare/OFF/parcelas + total no CTA
 */
(function () {
  function stripHtml(value) {
    var tmp = document.createElement('div');
    tmp.innerHTML = String(value == null ? '' : value);
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function moneyFromCents(cents, trailingZeros) {
    var amount = Number(cents) || 0;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var format =
          (window.theme && theme.moneyFormat) ||
          window.moneyFormat ||
          (window.Shopify && Shopify.money_format) ||
          'R$ {{amount_with_comma_separator}}';
        if (trailingZeros === false && amount % 100 === 0) {
          format =
            (window.theme && theme.moneyFormatWithoutTrailingZeros) ||
            'R$ {{amount_no_decimals}}';
        }
        return stripHtml(Shopify.formatMoney(amount, format));
      }
    } catch (e) {}
    if (trailingZeros === false && amount % 100 === 0) {
      return 'R$ ' + String(Math.round(amount / 100));
    }
    var value = (amount / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value;
  }

  function getRoot() {
    return document.querySelector('.xy-pdp-price[data-js-xy-price]');
  }

  function installmentCount() {
    var root = getRoot();
    var n = root ? parseInt(root.getAttribute('data-installments') || '6', 10) : 6;
    return n > 0 ? n : 6;
  }

  function unitPriceCents() {
    var root = getRoot();
    if (root) {
      var fromRoot = parseInt(root.getAttribute('data-unit-price'), 10);
      if (fromRoot > 0) return fromRoot;
    }
    var priceEl = document.querySelector('[data-js-xy-current-price]');
    if (!priceEl) return 0;
    var raw = priceEl.getAttribute('data-price');
    if (raw) {
      var parsed = parseInt(raw, 10);
      if (parsed > 0) return parsed;
    }
    return 0;
  }

  function qtyValue() {
    var qtyInput = document.querySelector('.cms-product-meta .js_qty, #Quantity');
    var qty = qtyInput ? parseInt(String(qtyInput.value).replace(/\D/g, ''), 10) : 1;
    var min = qtyInput ? parseInt(qtyInput.getAttribute('data-min') || qtyInput.min || '1', 10) : 1;
    if (!qty || qty < 1) qty = min > 0 ? min : 1;
    return qty;
  }

  function updateOrderTotal() {
    var totalEls = document.querySelectorAll('[data-js-xy-order-total]');
    if (!totalEls.length) return;
    var unit = unitPriceCents();
    if (!unit) return;
    var money = moneyFromCents(unit * qtyValue());
    totalEls.forEach(function (el) {
      el.textContent = money;
    });
  }

  function resolveCompare(price, variantCompare) {
    price = Number(price) || 0;
    variantCompare = Number(variantCompare) || 0;
    if (variantCompare > price) return variantCompare;

    var root = getRoot();
    if (!root) return 0;

    var compareMax = parseInt(root.getAttribute('data-compare-max') || '0', 10) || 0;
    if (compareMax > price) return compareMax;

    var suggested = parseInt(root.getAttribute('data-suggested') || '0', 10) || 0;
    if (suggested > price) return suggested;

    var priceVaries = root.getAttribute('data-price-varies') === 'true';
    var priceMax = parseInt(root.getAttribute('data-price-max') || '0', 10) || 0;
    if (priceVaries && priceMax > price) return priceMax;

    return 0;
  }

  function setSaleEls(compareEl, offEl, visible) {
    [compareEl, offEl].forEach(function (el) {
      if (!el) return;
      if (visible) {
        el.classList.remove('is-hidden', 'd-none');
        el.removeAttribute('hidden');
      } else {
        el.classList.add('is-hidden');
        el.setAttribute('hidden', '');
      }
    });
  }

  function applyPriceUI(price, compareAt) {
    var root = getRoot();
    if (!root) {
      updateOrderTotal();
      return;
    }

    price = Number(price) || 0;
    var compare = resolveCompare(price, compareAt);
    var discountPct =
      compare > price && compare > 0 ? Math.round(((compare - price) * 100) / compare) : 0;
    var parts = installmentCount();
    var installment = parts > 0 ? Math.floor(price / parts) : 0;

    root.setAttribute('data-unit-price', String(price));
    root.setAttribute('data-compare', String(compare));
    root.classList.toggle('xy-pdp-price--sale', discountPct > 0);

    var currentEl = root.querySelector('[data-js-xy-current-price]');
    var hiddenCompat = root.querySelector('[data-js-product-price]');
    var compareEl = root.querySelector('[data-js-xy-compare]');
    var offEl = root.querySelector('[data-js-xy-off]');
    var installmentsEl = root.querySelector('[data-js-xy-installments]');

    if (currentEl) {
      currentEl.setAttribute('data-price', String(price));
      currentEl.textContent = moneyFromCents(price);
    }
    if (hiddenCompat) {
      hiddenCompat.setAttribute('data-price', String(price));
      hiddenCompat.textContent = moneyFromCents(price);
    }
    if (compareEl) {
      if (discountPct > 0) {
        compareEl.setAttribute('data-price', String(compare));
        compareEl.textContent = moneyFromCents(compare);
      } else {
        compareEl.textContent = '';
      }
    }
    if (offEl) {
      offEl.textContent = discountPct > 0 ? discountPct + '% OFF' : '';
    }
    setSaleEls(compareEl, offEl, discountPct > 0);

    if (installmentsEl) {
      installmentsEl.textContent = parts + 'x ' + moneyFromCents(installment) + ' sem juros';
    }

    updateOrderTotal();
  }

  function readVariantFromJson(variantId) {
    var jsonEl = document.querySelector(
      '#product-single .data-json-product, .js_product_single .data-json-product'
    );
    if (!jsonEl) return null;
    try {
      var data = JSON.parse(jsonEl.textContent);
      var variants = data.variants || data;
      if (!Array.isArray(variants)) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }
    } catch (e) {}
    return null;
  }

  function syncFromVariantInput() {
    var input = document.querySelector(
      '[data-js-product-variant-input], form[data-type="add-to-cart-form"] input[name="id"]'
    );
    if (!input || !input.value) return;
    var variant = readVariantFromJson(input.value);
    if (!variant) return;
    applyPriceUI(variant.price, variant.compare_at_price || 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var page = document.querySelector('.main-content-detail');
    if (!page) return;

    page.addEventListener('click', function (e) {
      if (e.target.closest('.js_plus, .js_minus')) {
        setTimeout(updateOrderTotal, 50);
      }
      if (e.target.closest('.product-options__value, .cms-option-item')) {
        setTimeout(syncFromVariantInput, 100);
      }
    });

    page.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('js_qty')) {
        updateOrderTotal();
      }
      if (
        e.target &&
        (e.target.name === 'id' || e.target.hasAttribute('data-js-product-variant-input'))
      ) {
        setTimeout(syncFromVariantInput, 40);
      }
    });

    page.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('js_qty')) {
        updateOrderTotal();
      }
    });

    var variantInput = document.querySelector('[data-js-product-variant-input]');
    if (variantInput && window.MutationObserver) {
      var last = variantInput.value;
      var observer = new MutationObserver(function () {
        if (variantInput.value !== last) {
          last = variantInput.value;
          setTimeout(syncFromVariantInput, 40);
        }
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant || detail;
      if (variant && variant.price != null) {
        applyPriceUI(variant.price, variant.compare_at_price || 0);
      }
    });

    var priceRoot = getRoot();
    if (priceRoot) {
      applyPriceUI(
        parseInt(priceRoot.getAttribute('data-unit-price') || '0', 10),
        parseInt(priceRoot.getAttribute('data-compare') || '0', 10)
      );
    } else {
      updateOrderTotal();
    }

    function patchThemePrice() {
      if (!window.Alothemes || !Alothemes.ProductCurrency || !Alothemes.ProductCurrency.setPrice) {
        return false;
      }
      if (Alothemes.ProductCurrency.__xyPatched) return true;
      var original = Alothemes.ProductCurrency.setPrice.bind(Alothemes.ProductCurrency);
      Alothemes.ProductCurrency.setPrice = function ($price, price, compareAt) {
        var $el = $price && $price.jquery ? $price : window.jQuery ? window.jQuery($price) : null;
        if ($el && $el.closest && $el.closest('[data-js-xy-price]').length) {
          applyPriceUI(price, compareAt || 0);
          return;
        }
        return original($price, price, compareAt);
      };
      Alothemes.ProductCurrency.__xyPatched = true;
      return true;
    }

    if (!patchThemePrice()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (patchThemePrice() || tries > 40) clearInterval(timer);
      }, 250);
    }
  });
})();
